module.exports = __webpack_public_path__ + "img/m5.1d00ff43.png";